"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MARKETS = exports.TOKEN_MINTS = exports.getLayoutVersion = void 0;
const web3_js_1 = require("@solana/web3.js");
const markets_json_1 = __importDefault(require("./markets.json"));
const token_mints_json_1 = __importDefault(require("./token-mints.json"));
function getLayoutVersion(programId) {
    if (programId.equals(new web3_js_1.PublicKey('4ckmDgGdxQoPDLUkDT3vHgSAkzA3QRdNq5ywwY4sUSJn')) ||
        programId.equals(new web3_js_1.PublicKey('BJ3jrUzddfuSrZHXSCxMUUQsjKEyLmuuyZebkcaFp2fg'))) {
        return 1;
    }
    else if (programId.equals(new web3_js_1.PublicKey('EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o'))) {
        return 2;
    }
    else {
        return 3;
    }
}
exports.getLayoutVersion = getLayoutVersion;
exports.TOKEN_MINTS = token_mints_json_1.default.map((mint) => {
    return {
        address: new web3_js_1.PublicKey(mint.address),
        name: mint.name,
    };
});
exports.MARKETS = markets_json_1.default.map((market) => {
    return {
        address: new web3_js_1.PublicKey(market.address),
        name: market.name,
        programId: new web3_js_1.PublicKey(market.programId),
        deprecated: market.deprecated,
    };
});
//# sourceMappingURL=tokens_and_markets.js.map